import { cn } from "@util/helpers";

import { NominationsTabMobileProps } from "./types";

/**
 * Component to render events-awards nominations tabs for mobile
 */
const NominationsTabMobile = ({
  changeTab,
  closeDropdown,
  activeLabel,
  nominationsTabList,
  className,
}: NominationsTabMobileProps): React.ReactElement => {
  return (
    <div
      className="absolute z-10 mt-2 w-full bg-gray-150 py-3"
      data-testid="nominations-tab-mobile-component"
    >
      {nominationsTabList.map(({ key, label }) => (
        <div
          key={key}
          onClick={() => {
            changeTab(key);
            closeDropdown();
          }}
          className={cn(
            "cursor-pointer px-4 py-2 hover:bg-gray-100",
            className,
            { "bg-gray-650 text-white": activeLabel === label }
          )}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default NominationsTabMobile;
